export default __webpack_public_path__ + "static/media/USD.8151fb1b.png";